module.exports = __webpack_public_path__ + "01_short_brown.78865087.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_short_brown.png
// module id = NHb7
// module chunks = 0